<template>
    <footer class="mt-auto py-3">
        <div class="container">
            <div id="engagementRGPDFormulaire" class="row justify-content-center text-center">
                <div class="col-12 col-md-10">
                    <p class="text-justify-custom px-3">
                        *10% de remise sur vos achats, du 5 au 17 novembre 2025, uniquement dans votre espace braderie de Quimper Kerdroniou.
                        Non cumulable avec toute autre promotion. En vous inscrivant, vous acceptez de recevoir notre newsletter et nos offres par courrier,
                        et vous acceptez que vos données personnelles soient utilisées par Armor-Lux.
                        Pour en savoir plus, consultez notre page 
                        <a id="lien" href="https://www.armorlux.com/pages/politique-de-confidentialite">
                            "Politique de confidentialité" 
                        </a>sur le site.
                    </p>
                </div>
            </div>
            
        </div>
        <div class="lignes">
            <hr class="ligne-blanc">
            <hr class="ligne-rouge">
            <hr class="ligne-blanc-border">
        </div>
    </footer>
</template>

<script>

export default {
    name: 'MentionsLegales'
}

</script>

<style>
footer {
    background-color: var(--color-form-braderie);
}

#engagementRGPDFormulaire p {
    color: #ffffff;
    font-size: 10px;
}

.lignes hr {
  margin: 0.3em 0; /* réduit l’espace entre les lignes */
}

.ligne-blanc {
    background-color: #ffffff;
}

.ligne-rouge {
    background-color: #9f2834;
}

.ligne-blanc-border {
    background-color: #ffffff;
    border-top-width: 2px;
}

.text-justify-custom {
    text-align: justify;
    text-align-last: center;
}

#lien {
    color: #ffffff;
    text-decoration: underline !important;
}
</style>